module.exports = __webpack_public_path__ + "img/6.2313c7c7.png";